{
  "appName": "VA Profile",
  "entryFile": "./profile-entry.jsx",
  "entryName": "profile",
  "rootUrl": "/profile",
  "productId": "f9278bea-a113-4cb6-aed7-54dbaea258b0"
}
